/* 
* Add support for lazy loaded templates
*
*/

(function (SG, window, $) {
  SG.registerModule('templates');

  _.extend(SG, {
    _compiledTemplates: {},
    // if the template isn't compiled, compile it
    // id should correspond to the template's dom id
    // renders the template with passed optional data
    template: function(id, data) {
      var dict = this._compiledTemplates;
      if(!dict[id]) {
        dict[id] = _.template($('#'+id).html());
      }
      return (dict[id])(data);
    }
  });
})(SampleGraph, window, jQuery);



// WEBPACK FOOTER //
// ./public/javascripts/sample_graph/sample_graph.templates.js